import { render, staticRenderFns } from "./SmsOutboundBubble.vue?vue&type=template&id=63e3d8c1&scoped=true&"
import script from "./SmsOutboundBubble.vue?vue&type=script&lang=ts&"
export * from "./SmsOutboundBubble.vue?vue&type=script&lang=ts&"
import style0 from "./SmsOutboundBubble.vue?vue&type=style&index=0&id=63e3d8c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3d8c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VHover,VIcon,VRow,VTooltip})
